import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';
import { useDiscountFeedbackItems } from 'store/feedback';

export const AdminDiscountsLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  const { data: discountFeedbackItems } = useDiscountFeedbackItems({
    status: ['pending'],
  });

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('discounts.title'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'discounts',
                label: t('discounts.title'),
                url: ROUTES.admin.discounts.list,
                isActive: path === ROUTES.admin.discounts.list,
              },
              {
                key: 'reports',
                label: t('alternatives.reports.title'),
                url: ROUTES.admin.discounts.reports,
                isActive: path === ROUTES.admin.discounts.reports,
                badge: discountFeedbackItems?.total,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
